/**
 * Copyright © 2026 Adnuntius AS.
 */
import {AdnListHelperService} from '../common/controller/list-helper.service';
import {Component, Inject} from '@angular/core';

import template from './folio-list-page.component.html';
import {AdminListColumn, AdminResourceListPageBase} from '../common/controller/admin-resource-list-page-base';
import {getListChildren} from '../common/controller/resource-list-utils';
import {OBJECT_TYPE} from '../common/constants/object-type';
import {LineItemResource} from '../../components/api/resources/resource/line-item.resource';
import {LocalNetworkProfile} from '../../components/session/local-network-profile';

@Component({
  standalone: false,
  selector: 'adn-folio-list-page',
  template
})
export class FolioListPageComponent extends AdminResourceListPageBase {
  readonly itemStateName = 'app.adv.folios.folio';
  readonly advertiserItemStateName = 'app.adv.advertisers.advertiser';
  readonly teamItemStateName = 'app.adm.teams.team';
  readonly userItemStateName = 'app.adm.users.user';
  readonly lineItemStateName = 'app.adv.line-items.line-item';
  readonly tierItemStateName = 'app.adm.tiers.tier';

  readonly childColumns: AdminListColumn[] = [
    {param: 'name'},
    {param: 'userState'},
    {param: 'executionState'},
    {param: 'tier', label: 'tier'},
    {param: 'objectives', numeric: true},
    {param: 'startDate'},
    {param: 'endDate'},
    {param: 'updateTime'}
  ];

  private readonly fallbackColumns: AdminListColumn[] = [
    {param: 'name'},
    {param: 'externalReference', label: 'extReference'},
    {param: 'Advertiser', label: 'advertiser'},
    {param: 'Team', label: 'team'},
    {param: 'createUser'},
    {param: 'updateTime'}
  ];

  constructor(
    @Inject(LocalNetworkProfile) LocalNetworkProfile: any,
    private readonly adnListHelper: AdnListHelperService,
    @Inject(LineItemResource) private readonly LineItem: any
  ) {
    super(LocalNetworkProfile);
  }

  get visibleColumns(): AdminListColumn[] {
    return this.normalizeColumns(this.sortHeaderParams);
  }

  get sortHeaderParams(): any[] {
    if (this.list?.sel?.outputFields?.length) {
      return this.list.sel.outputFields;
    }
    return this.list?.defaultFields || this.fallbackColumns;
  }

  isFieldVisible(param: string): boolean {
    return this.isListFieldVisible(param, this.list?.defaultFields || this.fallbackColumns);
  }

  toggleChildren(item: any): void {
    this.list.getChildren?.(item);
  }

  childList(itemId: string): any {
    return this.list.children?.[itemId];
  }

  filtersResolved(): boolean {
    const list = this.list;
    if (!list) {
      return true;
    }
    return !!((!list.joinQuery || list.joinQuery.$resolved));
  }

  userLinkDisabled(): boolean {
    const perms = this.list?.perms || {};
    return perms.MANAGE_SYSTEM !== true
      && perms.AX_ADVERTISER_ADMIN !== true
      && perms.AX_ADVERTISER_TEAM_ADMIN !== true;
  }

  businessLinkDisabled(): boolean {
    return this.list?.perms?.MANAGE_BUSINESS !== true;
  }

  systemLinkDisabled(): boolean {
    return this.list?.perms?.MANAGE_SYSTEM !== true;
  }

  protected afterListInit(): void {
    if (!this.list) {
      return;
    }
    this.list.canExpand = true;
    if (!this.list.getChildren) {
      getListChildren(this.list, this.adnListHelper, OBJECT_TYPE.Folio, this.LineItem);
    }
  }
}
